import { render } from "./StudentVideos.vue?vue&type=template&id=6777ad9c&scoped=true"
import script from "./StudentVideos.vue?vue&type=script&lang=js"
export * from "./StudentVideos.vue?vue&type=script&lang=js"

import "./StudentVideos.vue?vue&type=style&index=0&id=6777ad9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6777ad9c"]])

export default __exports__